import {
  getPayoutMethods,
  getPendingPayouts,
  getCryptoCurrencyPayoutVerificationCode,
  postCryptoPayout,
  postWireTransferPayout,
} from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/utils/i18n';

Vue.use(Vuex);
let smsCounterInterval = null;
const TOTAL_SMS_CODE_TIMER = 300;

const state = {
  walletName: '',
  walletAddress: '',
  verificationCode: '',
  verificationCodeModel: {},
  cod_transaction: '',
  phoneNumber: '',
  currentState: 'IN_STEP1', // IN_STEP1 | IN_STEP2
  verificationCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
  payoutCompleteCodeStatus: {
    loading: false,
    success: false,
    error: false,
    verify_error: false,
  },
  counterTick: TOTAL_SMS_CODE_TIMER,
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  setCurrentState(state, val) {
    state.currentState = val;
  },
  setVerificationCodeModel(state, val) {
    state.verificationCodeModel = val;
  },
  setVerificationCodeStatus(state, row) {
    state.verificationCodeStatus = {
      ...state.verificationCodeStatus,
      ...row,
    };
  },
  setPayoutCompleteCodeStatus(state, row) {
    state.payoutCompleteCodeStatus = {
      ...state.payoutCompleteCodeStatus,
      ...row,
    };
  },
  resetCounter() {
    state.counterTick = TOTAL_SMS_CODE_TIMER;
  },
  decreaseCounterTick(state) {
    state.counterTick -= 1;
  },
  setCod_transaction(state, data) {
    state.cod_transaction = data;
  },
};

const actions = {
  tryGetACode({ commit, rootState, dispatch }, payload) {
    const payoutMethod = rootState.payoutStore.payoutMethods.filter(
      row => row.name_mstpayout_method === payload.cryptoKey,
    )[0];
    commit('setVerificationCodeStatus', { loading: true });
    getCryptoCurrencyPayoutVerificationCode({
      method: payoutMethod.pk_mstpayout_method,
      amount: payload.amount,
    }).then(r => {
      if (r.data.IsSuccess) {
        const verifyCodeResult = r.data.Data;
        if (verifyCodeResult.success) {
          commit('setVerificationCodeModel', verifyCodeResult);
          commit('setCurrentState', 'IN_STEP2');
          commit('setVerificationCodeStatus', { success: true, error: false });
          dispatch('resetCounter');
          dispatch('startCounter');
        } else {
          commit('setVerificationCodeStatus', {
            success: false,
            error: i18n.t('Exceptions.VerifyCode.' + verifyCodeResult.message),
          });
        }
      } else {
        if (r.data.ExceptionMessage[0] === 'ROLLOVER_REACHED') {
          commit('payoutStore/setRollover', { error: true }, { root: true });
        } else {
          commit('setVerificationCodeStatus', {
            success: false,
            error: r.data.ExceptionMessage[0],
          });
        }
      }
      commit('setVerificationCodeStatus', { loading: false });
    });
  },
  tryPostCryptoPayout({ commit, state, rootState, dispatch }, cryptoKey) {
    clearInterval(smsCounterInterval);
    const payoutMethod = rootState.payoutStore.payoutMethods.filter(row => row.name_mstpayout_method === cryptoKey)[0];
    const formData = {
      PayoutAmount: rootState.payoutStore.amount,
      PayoutMethod: payoutMethod.pk_mstpayout_method,
      Wallet_Name: state.walletName,
      Bitcoin_Address: state.walletAddress,
      crypto_validation_code: state.verificationCode,
    };
    postCryptoPayout(formData).then(r => {
      if (r.data.IsSuccess) {
        const payoutResult = r.data.Data;
        commit('setPayoutCompleteCodeStatus', { verify_error: false });
        if (payoutResult.status && payoutResult.status === 'OK' && payoutResult.payout.cod_transaction) {
          commit('setCurrentState', 'IN_STEP1');
          commit('setCod_transaction', payoutResult.payout.cod_transaction);
          dispatch('payoutStore/tryGetPendingPayouts', null, { root: true });
          commit('setPayoutCompleteCodeStatus', {
            success: true,
            error: false,
          });
        } else if (payoutResult.status && payoutResult.status === 'VERIFY_ERROR') {
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            verify_error: i18n.t('Exceptions.VerifyCode.' + payoutResult.message),
          });
        } else {
          commit('setCurrentState', 'IN_STEP1');
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            error: i18n.t('Exceptions.' + payoutResult.message),
          });
        }
      } else {
        commit('setPayoutCompleteCodeStatus', {
          success: false,
          error: r.data.ExceptionMessage,
        });
        dispatch('player/tryGetBalance', null, { root: true });
      }
    });
  },
  startCounter({ commit, state }) {
    commit('resetCounter');
    clearInterval(smsCounterInterval);
    smsCounterInterval = setInterval(() => {
      commit('decreaseCounterTick');
      if (state.counterTick <= 0) {
        clearInterval(smsCounterInterval);
        commit('setCurrentState', 'IN_STEP1');
        commit('setPayoutCompleteCodeStatus', {
          success: false,
          error: 'TIMEOUT_VERIFICATION',
        });
      }
    }, 1000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
